// extracted by mini-css-extract-plugin
module.exports = {"main_div":"OrderAmount_main_div__UZT8I","btn":"OrderAmount_btn__mBhch","amount":"OrderAmount_amount__1_kx4"};